export const B2B_EVENT_TYPES = [
  'Konferens',
  'Företagsfest',
  'Kickoff',
  'Gala',
  'Produktlansering',
  'Mässa',
  'Julfest',
  'Seminarium',
  'Annat',
] as const;

export type B2bEventType = (typeof B2B_EVENT_TYPES)[number];

export function isB2bEventType(value: string): value is B2bEventType {
  return (B2B_EVENT_TYPES as readonly string[]).includes(value);
}
